// src/router.js
import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from './components/RevisedLogin.vue';
import SettingsPage from './components/SettingsPage.vue';
import Home from './components/HomePage.vue';
import MeetingDetail from './components/RevisedMeeting.vue';
import TranscriptPage from './components/TranscriptPage.vue';
import Welcome from './components/WelcomePage.vue';
import SearchPage from './components/SearchPage.vue';
import AboutUs from './components/AboutUs.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';
import AiPolicy from './components/AiPolicy.vue';
import WelcomePrivacyPolicy from './components/WelcomePrivacyPolicy.vue';
import YearInReview from './components/TownMeeting.vue';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';


const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/settings',
    name: 'UserInformation',
    component: SettingsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/view/:id',
    name: 'MeetingDetail',
    component: MeetingDetail,
    meta: { requiresAuth: true },
  },
  {
    path: '/transcript/:id',
    name: 'TranscriptPage',
    component: TranscriptPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: Welcome,
    meta: { requiresAuth: true },
  },
  {
    path: '/search',
    name: 'Search',
    component: SearchPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: AboutUs,
    meta: { requiresAuth: true },
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: { requiresAuth: true },
  },
  {
    path: '/policy',
    name: 'Policy',
    component: WelcomePrivacyPolicy,
    meta: { requiresAuth: false },
  },
  {
    path: '/AIPolicy',
    name: 'AiPolicy',
    component: AiPolicy,
    meta: { requiresAuth: true },
  },
  {
    path: '/YearInReview',
    name: 'YearInReview',
    component: YearInReview,
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        unsubscribe();
        resolve(user);
      },
      (error) => {
        unsubscribe();
        reject(error);
      }
    );
  });
};

/* // Simplified Navigation Guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const currentUser = auth.currentUser;

  if (requiresAuth && !currentUser) {
    next('/'); // Redirect to login page if not authenticated
  } else {
    next(); // Proceed to route
  }
}); */

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresGuest = to.matched.some((record) => record.meta.requiresGuest);

  try {
    const currentUser = await getCurrentUser();

    // Handle authenticated routes
    if (requiresAuth && !currentUser) {
      next('/');
      return;
    }

    // Handle guest-only routes (like login page)
    if (requiresGuest && currentUser) {
      next('/home');
      return;
    }

    // Handle default route for authenticated users
    if (to.path === '/' && currentUser) {
      next('/home');
      return;
    }

    // Proceed with navigation
    next();
  } catch (error) {
    console.error('Navigation guard error:', error);
    next('/');
  }
});

export default router;
